/** @format */

export function technicianAssignmentOnDate(technician, dateStr) {
  if (!technician) return null;
  const scheduledLevel = technician.scheduledHierarchicalLevel || null;
  const scheduledDate = technician.scheduledRoleDate || null;
  const useScheduled = Boolean(
    scheduledLevel && scheduledDate && dateStr && dateStr >= scheduledDate,
  );
  const hierarchicalLevel = useScheduled
    ? scheduledLevel
    : technician.hierarchicalLevel || null;
  const isJoker = useScheduled
    ? Boolean(technician.scheduledIsJoker)
    : Boolean(technician.isJoker);
  return {
    hierarchical_level: hierarchicalLevel,
    is_leader: hierarchicalLevel === 'leader',
    is_joker: isJoker,
  };
}

/** @deprecated Use technicianAssignmentOnDate. Kept so existing call sites still work. */
export function technicianRoleOnDate(technician, _roles, dateStr) {
  return technicianAssignmentOnDate(technician, dateStr);
}

export function technicianIsJokerOnDate(technician, _roles, dateStr) {
  return Boolean(technicianAssignmentOnDate(technician, dateStr)?.is_joker);
}

export function jokerUsesInvertedAvailabilityOnDate(dateStr) {
  return Boolean(dateStr && dateStr >= '2026-06-09');
}

export function technicianUsesInvertedAvailabilityOnDate(
  technician,
  roles,
  dateStr,
) {
  return (
    technicianIsJokerOnDate(technician, roles, dateStr) &&
    jokerUsesInvertedAvailabilityOnDate(dateStr)
  );
}

export function technicianRoleSortRankOnDate(technician, roles, dateStr) {
  const assignment = technicianRoleOnDate(technician, roles, dateStr);
  if (assignment?.is_leader) return 0;
  if (assignment?.is_joker) return 2;
  return 1;
}

export function resolveTechnicianIsJoker(
  technicianId,
  technicians,
  roles,
  dateStr,
) {
  const tech = (technicians || []).find(
    (row) => Number(row.id) === Number(technicianId),
  );
  if (!tech) return false;
  return technicianIsJokerOnDate(tech, roles, dateStr);
}
